/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { ICommandBarItemProps } from '@fluentui/react/lib/CommandBar';

/**
 * This utility function centralizes the management of command bar item disability
 * based on the current selection count of the resource table the command bar
 * is currently on.
 *
 * @param commands An array of commands that the command bar supports.
 * @param noneKeys The command keys that are to be enabled when no items are selected.
 * @param singleKeys The command keys that are to be enabled when one item are selected.
 * @param multiKeys The command keys that are to be enabled when multiple items are selected.
 * @param selectionCount The number of selected items.
 * @returns All the commands edited with the disable prop.
 */
export const commandBarItemSelectionManager = (
    commands: ICommandBarItemProps[],
    noneKeys: string[],
    singleKeys: string[],
    multiKeys: string[],
    selectionCount: number
): ICommandBarItemProps[] => {
    let keySet: string[] = [];

    if (selectionCount === 0) {
        keySet = noneKeys;
    } else if (selectionCount === 1) {
        keySet = singleKeys;
    } else if (selectionCount > 1) {
        keySet = multiKeys;
    }

    commands
        .filter(command => keySet.indexOf(command.key) === -1)
        .forEach(command => {
            command.disabled = true;
        });

    return commands;
};
